import Store from '@/store/computed/storeHelpers'
export default {
  computed: {
    defaultHeaders: Store.getSet({ store: 'users', prop: 'defaultHeaders' })
  },
  data() {
    return {
      allPossibleHeaders: [
        {
          text: 'Name',
          align: 'center',
          value: 'name',
          type: 'text',
          show: false
        },
        {
          text: 'Client Read',
          align: 'center',
          value: 'clientRead',
          type: 'bool',
          group: 'master',
          show: false
        },
        {
          text: 'Client Write',
          align: 'center',
          value: 'clientWrite',
          type: 'bool',
          group: 'master',
          show: false
        },
        {
          text: 'Contractor Read',
          align: 'center',
          value: 'contractorRead',
          type: 'bool',
          group: 'master',
          show: false
        },
        {
          text: 'Contractor Write',
          align: 'center',
          value: 'contractorWrite',
          type: 'bool',
          group: 'master',
          show: false
        },
        {
          text: 'Rate Read',
          align: 'center',
          value: 'rateRead',
          type: 'bool',
          group: 'master',
          show: false
        },
        {
          text: 'Rate Write',
          align: 'center',
          value: 'rateWrite',
          type: 'bool',
          group: 'master',
          show: false
        },
        {
          text: 'Tip Read',
          align: 'center',
          value: 'tipRead',
          type: 'bool',
          group: 'master',
          show: false
        },
        {
          text: 'Tip Write',
          align: 'center',
          value: 'tipWrite',
          type: 'bool',
          group: 'master',
          show: false
        },
        {
          text: 'User Read',
          align: 'center',
          value: 'userRead',
          type: 'bool',
          group: 'master',
          show: false
        },
        {
          text: 'User Write',
          align: 'center',
          value: 'userWrite',
          type: 'bool',
          group: 'master',
          show: false
        },
        {
          text: 'Show Cost',
          align: 'center',
          value: 'showCost',
          type: 'bool',
          group: 'cost',
          show: false
        },
        {
          text: 'Show Sell',
          align: 'center',
          value: 'showSell',
          type: 'bool',
          group: 'cost',
          show: false
        },
        {
          text: 'Allocation Read',
          align: 'center',
          value: 'allocationRead',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'Allocation Write',
          align: 'center',
          value: 'allocationWrite',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'Allocation Staging Read',
          align: 'center',
          value: 'allocationStagingRead',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'Allocation Staging Write',
          align: 'center',
          value: 'allocationStagingWrite',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'Billing Read',
          align: 'center',
          value: 'billingRead',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'Billing Write',
          align: 'center',
          value: 'billingWrite',
          type: 'bool',
          group: 'transaction',
          show: false
        },

        {
          text: 'Compliance Read',
          align: 'center',
          value: 'complianceRead',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'Compliance Write',
          align: 'center',
          value: 'complianceWrite',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'Docket Read',
          align: 'center',
          value: 'docketRead',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'Docket Write',
          align: 'center',
          value: 'docketWrite',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'RCTI Read',
          align: 'center',
          value: 'rctiRead',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'RCTI Write',
          align: 'center',
          value: 'rctiWrite',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'Tipping Read',
          align: 'center',
          value: 'tippingRead',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'Tipping Write',
          align: 'center',
          value: 'tippingWrite',
          type: 'bool',
          group: 'transaction',
          show: false
        },

        {
          text: 'Allocation Staging Entry',
          align: 'center',
          value: 'allocationStagingEntry',
          type: 'bool',
          group: 'dataEntry',
          show: false
        },
        {
          text: 'Allow Docket Entry',
          align: 'center',
          value: 'allowDocketEntry',
          type: 'bool',
          group: 'dataEntry',
          show: false
        },
        {
          text: 'Allow Induction Entry',
          align: 'center',
          value: 'allowInductionEntry',
          type: 'bool',
          group: 'dataEntry',
          show: false
        },
        {
          text: 'Allow Tipping Entry',
          align: 'center',
          value: 'tippingEntry',
          type: 'bool',
          group: 'dataEntry',
          show: false
        },

        {
          text: 'Approved Bill Line Read',
          align: 'center',
          value: 'approvedBillLineRead',
          type: 'bool',
          group: 'transaction',
          show: false
        },
        {
          text: 'Approved Bill Line Write',
          align: 'center',
          value: 'approvedBillLineWrite',
          type: 'bool',
          group: 'transaction',
          show: false
        }
      ]
    }
  },
  mounted: []
}
